import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pn-button',
  templateUrl: './pn-button.component.html',
  styleUrls: ['./pn-button.component.scss'],
})
export class PnButtonComponent implements OnInit {
  @Input() public id;
  @Input() public type;
  @Input() public name;
  @Input() public label;
  @Input() public disabled = false;
  @Input() public loading = false;

  ngOnInit() {}
}
